/**
 * First visible plain-text line from a report description (HTML or plain).
 * Block tags and <br> become line breaks so Quill paragraphs stay distinct.
 */
export function firstPlainLineFromHtml(html) {
  if (html == null) return "";
  const raw = String(html);
  if (!raw.trim()) return "";

  const withBreaks = raw
    .replace(/<\s*br\s*\/?>/gi, "\n")
    .replace(/<\/\s*(p|div|li|h[1-6]|tr|blockquote)\s*>/gi, "\n");

  const tmp = document.createElement("div");
  tmp.innerHTML = withBreaks;
  const plain = (tmp.textContent || tmp.innerText || "").replace(/\u00a0/g, " ");

  const line =
    plain
      .split(/\r?\n/)
      .map((part) => part.replace(/\s+/g, " ").trim())
      .find((part) => part.length > 0) || "";

  return line;
}

export function hasReportDescription(html) {
  return firstPlainLineFromHtml(html).length > 0;
}
